import _ from 'lodash';
import createjs from 'createjs-collection';
import Color from 'color';

import * as fJS from './../cjsRoot/fJS';
import { cjsItem } from './../cjsRoot/cjsBase';
import { cjsPoint } from './../cjsObjects/cjsPoint';
import { cjsEffects } from './../cjsObjects/cjsEffects';

var blockMove = false;

export class cjsConnect extends cjsItem {
  _lines = [];
  _line;
  _removedLine = false;

  constructor(obj) {
    super(obj);
    this._line = false;
  }

  stageMouseDown(e, data) {
    console.log('cjsConnect: DOWN - id: ' + data.engine.id);
    let engine = data.engine,
      stage = data.cjsStage,
      mouse = new createjs.Point(Math.floor(e.stageX), Math.floor(e.stageY));
    stage.resetCheckStatus();

    if (stage.mousedown || engine.block === true) {
      e.stopPropagation();
      return false;
    }
    engine._mousedown = true;
    stage.mousedown = true;

    let idPoint = cjsPoint.prototype.findPoint(engine, mouse);
    if (idPoint === false) {
      e.stopPropagation();
      return;
    }

    engine.points[idPoint].visible = true;
    let st = engine.container.localToGlobal(engine.points[idPoint].x, engine.points[idPoint].y);

    engine.line = new cjsLine(
      _.merge(engine.otherProperty, {
        stage: stage,
        idGroup: engine.idGroup,
        idItem: engine.id,
        idPoint: idPoint,
        start: { x: st.x - stage.offset.x, y: st.y - stage.offset.y },
        stop:
          this.freeDrawing === true
            ? { x: st.x - stage.offset.x, y: st.y - stage.offset.y }
            : { x: mouse.x - stage.offset.x, y: mouse.y - stage.offset.y },
      })
    );

    engine.line.redraw('select', stage);

    stage._stage.addChild(engine.line.shape);

    stage.listener.pm = stage._stage.on('pressmove', engine._stageMouseMove, null, false, {
      engine: engine,
      cjsStage: stage,
    });

    e.stopPropagation();
  }

  _stageMouseMove(e, data) {
    let engine = data.engine,
      stage = data.cjsStage,
      mouse = new createjs.Point(Math.floor(e.stageX), Math.floor(e.stageY));
    //    if (stage.mousedown !== true || engine._mousedown !== true) { e.stopPropagation(); return false; }

    engine.line.stop = {
      x: mouse.x - stage.offset.x,
      y: mouse.y - stage.offset.y,
    };
    engine.line.redraw('select', stage);

    if (engine.freeDrawing === true) {
      engine.line.start = {
        x: mouse.x - stage.offset.x,
        y: mouse.y - stage.offset.y,
      };
    }
  }

  stageMouseUp(e, data) {
    console.log('cjsConnect: UP - id: ' + data.engine.id);
    let engine = data.engine,
      stage = data.cjsStage,
      mouse = new createjs.Point(Math.floor(e.stageX), Math.floor(e.stageY));
    if (stage.mousedown !== true) {
      if (engine.line !== false) stage._stage.removeChild(engine.line.shape);
      stage.mousedown = false;
      engine._mousedown = false;
      e.stopPropagation();
      return;
    }
    stage.mousedown = false;
    engine._mousedown = false;

    let find = stage.getObjectUnderPoint({
      x: mouse.x - stage.offset.x,
      y: mouse.y - stage.offset.y,
    });
    if (find === false) {
      return engine._stopDraw(e, true);
    }
    find.idPoint = cjsPoint.prototype.findPoint(stage.groups[find.idGroup].items[find.idItem], mouse);
    if (find.idPoint === false) {
      return engine._stopDraw(e, true);
    }

    stage.groups[find.idGroup].items[find.idItem].points[find.idPoint].visible = true;

    engine.line.connect.idGroup2 = find.idGroup;
    engine.line.connect.idItem2 = find.idItem;
    engine.line.connect.idPoint2 = find.idPoint;

    let connect = engine._checkConnect();

    // connect -> false => ta sama grupa, linia do usunięcia
    // connect -> true => nowa linia
    // connect -> Object => znaleziona w ( idGroup, idItem i idLine )

    if (connect === false) {
      return engine._stopDraw(e, true);
    }

    // { idGroup: this.line.connect.idGroup2, idItem: this.line.connect.idItem2, idLine: i };

    if (connect !== true) {
      let line = stage.groups[connect.idGroup].items[connect.idItem].lines[connect.idLine];
      if (line.block === true) {
        return engine._stopDraw(e, true);
      }
      stage.groups[connect.idGroup].items[connect.idItem]._removeLine(connect.idLine);
    }

    let poi = stage.groups[find.idGroup].items[find.idItem].container.localToGlobal(
      stage.groups[find.idGroup].items[find.idItem].points[find.idPoint].x,
      stage.groups[find.idGroup].items[find.idItem].points[find.idPoint].y
    );

    engine.line.stop = { x: poi.x - stage.offset.x, y: poi.y - stage.offset.y };

    if (engine.freeDrawing === false) engine.line.redraw('connect', stage);
    else {
      engine.line.redrawFree('connect', stage);
    }

    engine.lines[engine.line.id] = engine.line;

    stage.sounds.play(engine.idGroup + '.' + engine.id + '.mouseup');

    engine._stopDraw(e);

    if (stage.autoCheckAllCorrect === true && cjsConnect.checkGameAction.call(this, stage, false) === true) {
      console.log('autoCheckAllCorrect');
      stage._mixins.$store.dispatch('checkGame');
    }
  }

  _removeLine(idLine, hides) {
    console.log('remove line: ' + idLine);

    let line = _.cloneDeep(this.lines[idLine].connect);
    if (this.lines[idLine].block === true) {
      return false;
    }

    if (this.lines[idLine].shape.cacheID !== 0) {
      this.lines[idLine].shape.uncache();
    }

    if (this.hideLineAnimation === true && hides === true) {
      this.lines[idLine].setTime();
      this.lines[idLine].toVisible = false;
      this.lines[idLine].wait = this.waitAnimation;
      this.lines[idLine].remove = true;

      this._removedLine = true;
      return false;
    }

    console.log(idLine + ' REMOVE: ' + this._stage._stage.removeChild(this.lines[idLine].shape));
    delete this.lines[idLine];
  }

  checkPoints(st) {
    let stage = typeof st === 'object' && st !== null ? st : this._stage;
    for (let gr in stage.groups) {
      for (let i in stage.groups[gr].items) {
        for (let p in stage.groups[gr].items[i].points) {
          if (typeof stage.groups[gr].items[i].points[p] !== 'object' || stage.groups[gr].items[i].points[p] === null)
            continue;
          stage.groups[gr].items[i].points[p].visible = false;
        }
      }
    }

    for (let gr in stage.groups) {
      for (let i in stage.groups[gr].items) {
        for (let l in stage.groups[gr].items[i].lines) {
          if (typeof stage.groups[gr].items[i].lines[l] !== 'object' || stage.groups[gr].items[i].lines[l] === null)
            continue;
          let c = stage.groups[gr].items[i].lines[l].connect;
          stage.groups[c.idGroup].items[c.idItem].points[c.idPoint].visible = true;
          stage.groups[c.idGroup2].items[c.idItem2].points[c.idPoint2].visible = true;
        }
      }
    }
  }

  _checkConnect(cjsLine) {
    let line = typeof cjsLine === 'object' && cjsLine !== null ? cjsLine : this.line;

    if (line.connect.idGroup === line.connect.idGroup2) return false;
    for (let i in this.lines) {
      let l = this.lines[i];
      if (typeof l !== 'object' || l === null) continue;
      if (
        (line.connect.idGroup === l.connect.idGroup &&
          line.connect.idItem === l.connect.idItem &&
          line.connect.idGroup2 === l.connect.idGroup2 &&
          line.connect.idItem2 === l.connect.idItem2) ||
        (line.connect.idGroup === l.connect.idGroup2 &&
          line.connect.idItem === l.connect.idItem2 &&
          line.connect.idGroup2 === l.connect.idGroup &&
          line.connect.idItem2 === l.connect.idItem)
      )
        return {
          idGroup: line.connect.idGroup,
          idItem: line.connect.idItem,
          idLine: i,
        };
    }

    for (let i in this._stage.groups[line.connect.idGroup2].items[line.connect.idItem2].lines) {
      let l = this._stage.groups[line.connect.idGroup2].items[line.connect.idItem2].lines[i];
      if (typeof l !== 'object' || l === null) continue;

      if (
        (line.connect.idGroup === l.connect.idGroup &&
          line.connect.idItem === l.connect.idItem &&
          line.connect.idGroup2 === l.connect.idGroup2 &&
          line.connect.idItem2 === l.connect.idItem2) ||
        (line.connect.idGroup === l.connect.idGroup2 &&
          line.connect.idItem === l.connect.idItem2 &&
          line.connect.idGroup2 === l.connect.idGroup &&
          line.connect.idItem2 === l.connect.idItem)
      )
        return {
          idGroup: line.connect.idGroup2,
          idItem: line.connect.idItem2,
          idLine: i,
        };
    }

    return true;
  }

  _findConnect() {
    let connect = [];
    for (let gr in this._stage.groups) {
      if (gr === this.idGroup) continue;
      for (let i in this._stage.groups[gr].items) {
        for (let l in this._stage.groups[gr].items[i].lines) {
          if (
            typeof this._stage.groups[gr].items[i].lines[l] !== 'object' ||
            this._stage.groups[gr].items[i].lines[l] === null
          )
            continue;
          if (
            this._stage.groups[gr].items[i].lines[l].connect.idGroup2 === this.idGroup &&
            this._stage.groups[gr].items[i].lines[l].connect.idItem2 === this.id
          ) {
            connect.push(
              _.merge(this._stage.groups[gr].items[i].lines[l].connect, {
                idLine: l,
              })
            );
          }
        }
      }
    }
    console.log(connect);
    return connect;
  }

  _stopDraw(e, remove) {
    if (remove === true) {
      this._stage._stage.removeChild(this.line.shape);
    }

    delete this._line;
    this.line = false;

    this.checkPoints();

    this._stage.mousedown = false;
    this._mousedown = false;
    this._stage._stage.off('pressmove', this._stage.listener.pm);

    e.stopPropagation();
    return false;
  }

  get hideLineAnimation() {
    return typeof this.otherProperty.lines === 'object' &&
      typeof this.otherProperty.lines.hideLineAnimation === 'boolean'
      ? this.otherProperty.lines.hideLineAnimation
      : this._stage.defConfig.lines.hideLineAnimation;
  }
  get waitAnimation() {
    return typeof this.otherProperty.lines === 'object' &&
      typeof this.otherProperty.lines.hide === 'object' &&
      fJS.isNumeric(this.otherProperty.lines.hide.wait)
      ? this.otherProperty.lines.hide.wait
      : this._stage.defConfig.lines.hide.wait;
  }

  get freeDrawing() {
    return typeof this.otherProperty.lines === 'object' &&
      this.otherProperty.lines !== null &&
      typeof this.otherProperty.lines.freeDrawing === 'boolean'
      ? this.otherProperty.lines.freeDrawing
      : this._stage.defConfig.lines.freeDrawing;
  }
  get line() {
    return this._line;
  }
  set line(v) {
    this._line = v;
  }
  get lines() {
    return this._lines;
  }
  set lines(v) {
    this._lines = v;
  }
}

cjsConnect.tick = function(stage) {
  for (let gr in stage.groups) {
    let lines = [];
    for (let i in stage.groups[gr].items) {
      if (stage.groups[gr].items[i]._removedLine === true) {
        for (let l in stage.groups[gr].items[i].lines) {
          if (stage.groups[gr].items[i].lines[l].remove === true) {
            stage.groups[gr].items[i].lines[l]._moved = true;
            lines.push({ line: stage.groups[gr].items[i].lines[l], id: i });
          }
        }
      }
    }
    for (let i = 0; i < lines.length; i++) {
      if (cjsEffects[lines[i].line.effect].call(this, lines[i].line) === false) {
        continue;
      }
      if (lines[i].line._moved === false) {
        stage.groups[gr].items[lines[i].id].lines[lines[i].line.id].remove = false;
        console.log(lines[i].line.id + ' REMOVE: ' + stage._stage.removeChild(lines[i].line.shape));
        delete stage.groups[gr].items[lines[i].id].lines[lines[i].line.id];

        let r = false;
        for (let l in stage.groups[gr].items[lines[i].id].lines) {
          if (stage.groups[gr].items[lines[i].id].lines[l].remove === true) {
            r = true;
          }
        }

        stage.groups[gr].items[lines[i].id]._removedLine = r;
        stage.groups[lines[i].line.connect.idGroup].items[lines[i].line.connect.idItem].checkPoints();
      }
      lines.splice(i, 1);
    }
  }
};

cjsConnect.checkGameAction = function(stage, droped) {
  console.log('cjsConnect CHECK');
  let isCorrect = true;

  for (let gr in stage.groups) {
    for (let i in stage.groups[gr].items) {
      if (stage.groups[gr].items[i].block !== true) stage.groups[gr].items[i].isCorrect = true;
      for (let l in stage.groups[gr].items[i].lines) {
        if (typeof stage.groups[gr].items[i].lines[l] !== 'object' || stage.groups[gr].items[i].lines[l] === null)
          continue;
        stage.groups[gr].items[i].lines[l].isCorrect = -1;

        if (droped !== false) {
          if (stage.groups[gr].items[i].freeDrawing === false)
            stage.groups[gr].items[i].lines[l].redraw('connect', stage);
          else {
            stage.groups[gr].items[i].lines[l].redrawFree('connect', stage);
          }
        }
      }
    }
  }

  for (let gr in stage.groups) {
    for (let i in stage.groups[gr].items) {
      console.log('GRUPA: ' + gr + ' ITEM ' + i);

      let findConnect = stage.groups[gr].items[i]._findConnect();
      if (
        stage.groups[gr].items[i].correct.length !==
        findConnect.length + Object.keys(stage.groups[gr].items[i].lines).length
      ) {
        stage.groups[gr].items[i].isCorrect = false;
        console.log('ZŁA LICZBA POŁĄCZEŃ: ' + gr + ' ' + ' item ' + i);
      } else console.log('DOBRA LICZBA POŁĄCZEŃ ' + gr + ' ' + ' item ' + i);

      if (stage.bruteForce === false && stage.groups[gr].items[i].isCorrect === false) {
        //        if (stage.groups[gr].items[i].isCorrect === false) {
        for (let c in findConnect) {
          if (typeof findConnect[c] !== 'object' || findConnect[c] === null) continue;
          //      if (stage.bruteForce === false)
          stage.groups[findConnect[c].idGroup].items[findConnect[c].idItem].lines[
            findConnect[c].idLine
          ].isCorrect = false;
          stage.groups[findConnect[c].idGroup].items[findConnect[c].idItem].isCorrect = false;
        }
        //    if (stage.bruteForce === false) {
        for (let l in stage.groups[gr].items[i].lines) {
          if (typeof stage.groups[gr].items[i].lines[l] !== 'object' || stage.groups[gr].items[i].lines[l] === null)
            continue;

          stage.groups[gr].items[i].lines[l].isCorrect = false;
          //     }
        }
        continue;
      }

      for (let l in stage.groups[gr].items[i].lines) {
        if (typeof stage.groups[gr].items[i].lines[l] !== 'object' || stage.groups[gr].items[i].lines[l] === null)
          continue;

        for (let k in stage.groups[gr].items[i].correct) {
          if (typeof stage.groups[gr].items[i].correct[k] !== 'object' || stage.groups[gr].items[i].correct[k] === null)
            continue;
          //        console.log(stage.groups[gr].items[i].correct[k]);
          console.log('BLEBLE');
          console.log(
            stage.groups[gr].items[i].lines[l].connectTo(
              typeof stage.groups[gr].items[i].correct[k].idPoint === 'string'
            )
          );
          //        console.log(stage.groups[gr].items[i].lines[l].connect);
          let LineCorrect = stage.groups[gr].items[i].isEqual(
            stage.groups[gr].items[i].correct[k],
            stage.groups[gr].items[i].lines[l].connectTo(
              typeof stage.groups[gr].items[i].correct[k].idPoint === 'string'
            )
          );

          if (stage.bruteForce === true && LineCorrect === true) {
            stage.groups[gr].items[i].lines[l].isCorrect = true;
            continue;
          }
          stage.groups[gr].items[i].lines[l].isCorrect =
            stage.groups[gr].items[i].lines[l].isCorrect === -1
              ? LineCorrect
              : stage.groups[gr].items[i].lines[l].isCorrect;
        }
      }
    }
  }

  // stage.defConfig.removeInCorrects
  // stage.defConfig.bruteForce
  // stage.defConfig.correctBlock

  for (let gr in stage.groups) {
    for (let i in stage.groups[gr].items) {
      for (let l in stage.groups[gr].items[i].lines) {
        if (typeof stage.groups[gr].items[i].lines[l] !== 'object' || stage.groups[gr].items[i].lines[l] === null)
          continue;
        console.log('line: ' + l + ' isCorrect: ' + stage.groups[gr].items[i].lines[l].isCorrect);
        if (stage.groups[gr].items[i].isCorrect === false && stage.groups[gr].items[i].lines[l].isCorrect === -1)
          stage.groups[gr].items[i].lines[l].isCorrect = false;
        if (stage.groups[gr].items[i].lines[l].isCorrect === true) {
          if (droped !== false) {
            if (stage.correctBlock === true) stage.groups[gr].items[i].lines[l].block = true;
            if (stage.groups[gr].items[i].freeDrawing === false)
              stage.groups[gr].items[i].lines[l].redraw('good', stage);
            else {
              stage.groups[gr].items[i].lines[l].redrawFree('good', stage);
            }
          }
          continue;
        }
        stage.groups[gr].items[i].isCorrect = false;
        stage.groups[stage.groups[gr].items[i].lines[l].connect.idGroup].items[
          stage.groups[gr].items[i].lines[l].connect.idItem
        ].isCorrect = false;
        stage.groups[stage.groups[gr].items[i].lines[l].connect.idGroup2].items[
          stage.groups[gr].items[i].lines[l].connect.idItem2
        ].isCorrect = false;

        if (droped !== false) {
          if (stage.groups[gr].items[i].lines[l].isCorrect === false && stage.removeInCorrects === true) {
            stage.groups[gr].items[i].lines[l].redraw('bad', stage);
            stage.groups[gr].items[i]._removeLine(l, true);
            continue;
          }
          if (stage.groups[gr].items[i].lines[l].isCorrect === false) {
            if (stage.groups[gr].items[i].freeDrawing === false)
              stage.groups[gr].items[i].lines[l].redraw('bad', stage);
            else {
              stage.groups[gr].items[i].lines[l].redrawFree('bad', stage);
            }
          }
        }
      }
    }
  }

  for (let gr in stage.groups) {
    for (let i in stage.groups[gr].items) {
      if (stage.groups[gr].items[i].isCorrect === true && stage.correctBlock === true && droped !== false)
        stage.groups[gr].items[i].block = true;
      isCorrect = stage.groups[gr].items[i].isCorrect === false ? false : isCorrect;
      console.log('GR: ' + gr + ' item: ' + i + ' isCorrect: ' + stage.groups[gr].items[i].isCorrect);
    }
  }

  if (stage.removeInCorrects === true && droped !== false) cjsConnect.prototype.checkPoints(stage);

  return isCorrect;
};

cjsConnect.resetGameAction = function(stage) {
  console.log('cjsConnect RESET');
  stage._stage.off('pressmove', stage.listener.pm);
};

class cjsLine {
  _shape;
  _block;
  _start;
  _stop;
  _connect = {};
  _colors;
  _freeDrawing;
  _isCorrect;
  _cacheData;

  _effect;
  _speed;
  _wait;
  _waitStart;
  _autoHide;
  _time;
  _toVisible;
  _remove = false;

  constructor(obj) {
    console.log(obj);
    this._connect.idGroup = obj.idGroup;
    this._connect.idItem = obj.idItem;
    this._connect.idPoint = obj.idPoint;
    this._freeDrawing =
      typeof obj.lines === 'object' && obj.lines !== null && typeof obj.lines.freeDrawing === 'boolean'
        ? obj.lines.freeDrawing
        : obj.stage.defConfig.lines.freeDrawing;
    this._block = false;
    this._isCorrect = false;
    this._colors = _.cloneDeep(obj.stage.defConfig.lines);
    if (typeof obj.lines === 'object' && obj.lines !== null)
      this._colors = _.merge(_.cloneDeep(obj.stage.defConfig.lines), obj.lines);

    this._colors['connect'].hideLine =
      typeof obj.lines === 'object' &&
      typeof obj.lines.connect === 'object' &&
      typeof obj.lines.connect.hideLine === 'boolean'
        ? obj.lines.connect.hideLine
        : typeof obj.lines === 'object' && typeof obj.lines.hideLine === 'boolean'
        ? obj.lines.hideLine
        : obj.stage.defConfig.lines.connect.hideLine;
    this._colors['select'].hideLine =
      typeof obj.lines === 'object' &&
      typeof obj.lines.select === 'object' &&
      typeof obj.lines.select.hideLine === 'boolean'
        ? obj.lines.select.hideLine
        : typeof obj.lines === 'object' && typeof obj.lines.hideLine === 'boolean'
        ? obj.lines.hideLine
        : obj.stage.defConfig.lines.select.hideLine;
    this._colors['good'].hideLine =
      typeof obj.lines === 'object' &&
      typeof obj.lines.good === 'object' &&
      typeof obj.lines.good.hideLine === 'boolean'
        ? obj.lines.good.hideLine
        : typeof obj.lines === 'object' && typeof obj.lines.hideLine === 'boolean'
        ? obj.lines.hideLine
        : obj.stage.defConfig.lines.good.hideLine;
    this._colors['bad'].hideLine =
      typeof obj.lines === 'object' && typeof obj.lines.bad === 'object' && typeof obj.lines.bad.hideLine === 'boolean'
        ? obj.lines.bad.hideLine
        : typeof obj.lines === 'object' && typeof obj.lines.hideLine === 'boolean'
        ? obj.lines.hideLine
        : obj.stage.defConfig.lines.bad.hideLine;

    delete this._colors.freeDrawing;
    this._shape = new createjs.Shape();
    this._shape.name = 'line_' + this._shape.id;

    this._shape.listener = {
      md: this._shape.on('mousedown', this.stageMouseDown, null, false, {
        line: this,
        cjsStage: obj.stage,
      }),
      c: this._shape.on('click', this._stageMouseClick, null, false, {
        line: this,
        cjsStage: obj.stage,
      }),
    };

    this._start = typeof obj.start === 'object' && obj.start !== null ? obj.start : { x: 0, y: 0 };
    this._stop = typeof obj.stop === 'object' && obj.stop !== null ? obj.stop : { x: 0, y: 0 };

    this._speed =
      typeof obj.lines === 'object' && typeof obj.lines.hide === 'object' && fJS.isNumeric(obj.lines.hide.speed)
        ? obj.lines.hide.speed
        : obj.stage.defConfig.lines.hide.speed;
    this._wait =
      typeof obj.lines === 'object' && typeof obj.lines.hide === 'object' && fJS.isNumeric(obj.lines.hide.wait)
        ? obj.lines.hide.wait
        : obj.stage.defConfig.lines.hide.wait;
    this._effect =
      typeof obj.lines === 'object' &&
      typeof obj.lines.hide === 'object' &&
      typeof cjsEffects[obj.lines.hide.effect] === 'function'
        ? obj.lines.hide.effect
        : obj.stage.defConfig.lines.hide.effect;

    if (this.freeDrawing === true) {
      this._cacheData = {
        x: this._start.x,
        x2: this._stop.x,
        y: this._start.y,
        y2: this._stop.y,
        w: 0,
        h: 0,
        ls: this.color['select'].size,
      };
    }
  }

  redraw(color, stage) {
    if (this.freeDrawing !== true) {
      this._shape.graphics.clear();
    }

    this._shape.graphics
      .s(this.color[color].color)
      .ss(this.color[color].size, 'round')
      .mt(this._start.x, this._start.y)
      .lt(this._stop.x, this._stop.y);

    if (this.freeDrawing === true) {
      this._updateCacheData();
    }

    if (this._shape.cacheID > 0) {
      this._shape.updateCache();
    }

    let zIndx = stage._stage.getChildIndex(stage.groups[this.connect.idGroup].container),
      zIndx2 =
        typeof this.connect.idGroup2 === 'string'
          ? stage._stage.getChildIndex(stage.groups[this.connect.idGroup2].container)
          : -1;
    if (zIndx2 === -1) return;

    if (this.color[color].hideLine === true) {
      stage._stage.setChildIndex(this._shape, zIndx2 < zIndx ? zIndx2 : zIndx);
    } else {
      stage._stage.setChildIndex(this._shape, zIndx2 > zIndx ? zIndx2 : zIndx);
    }
  }

  redrawFree(color, stage) {
    let c = new Color(this.color[color].color);
    this._shape.filters = [new createjs.ColorFilter(0, 0, 0, 1, c.red(), c.green(), c.blue(), 1)];
    this._shape.cache(
      this._cacheData.x - this._cacheData.ls,
      this._cacheData.y - this._cacheData.ls,
      this._cacheData.w,
      this._cacheData.h
    );

    let zIndx = stage._stage.getChildIndex(stage.groups[this.connect.idGroup].container),
      zIndx2 =
        typeof this.connect.idGroup2 === 'string'
          ? stage._stage.getChildIndex(stage.groups[this.connect.idGroup2].container)
          : -1;
    if (zIndx2 === -1) return;

    if (this.color[color].hideLine === true) {
      stage._stage.setChildIndex(this._shape, zIndx2 < zIndx ? zIndx2 : zIndx);
    } else {
      stage._stage.setChildIndex(this._shape, zIndx2 > zIndx ? zIndx2 : zIndx);
    }
  }

  connectTo(point) {
    if (point === true)
      return {
        idGroup: this.connect.idGroup2,
        idItem: this.connect.idItem2,
        idPoint: this.connect.idPoint2,
      };
    return { idGroup: this.connect.idGroup2, idItem: this.connect.idItem2 };
  }

  connected(point) {
    if (point === true)
      return {
        idGroup: this.connect.idGroup,
        idItem: this.connect.idItem,
        idPoint: this.connect.idPoint,
      };
    return { idGroup: this.connect.idGroup, idItem: this.connect.idItem };
  }

  stageMouseDown(e, data) {
    console.log('cjsLine: DOWN');
    e.stopPropagation();
  }

  _stageMouseClick(e, data) {
    console.log('cjsLine: CLICK');
    let line = data.line,
      stage = data.cjsStage;
    stage.resetCheckStatus();
    stage.groups[line.connect.idGroup].items[line.connect.idItem]._removeLine(line.id);
    stage.groups[line.connect.idGroup].items[line.connect.idItem].checkPoints();

    stage.mousedown = false;
    stage.groups[line.connect.idGroup].items[line.connect.idItem]._mousedown = false;
    e.stopPropagation();
  }

  _updateCacheData() {
    if (this._cacheData.x > this._stop.x) this._cacheData.x = this._stop.x;
    if (this._cacheData.x2 < this._stop.x) this._cacheData.x2 = this._stop.x;
    if (this._cacheData.y > this._stop.y) this._cacheData.y = this._stop.y;
    if (this._cacheData.y2 < this._stop.y) this._cacheData.y2 = this._stop.y;

    if (this._cacheData.y2 > this._cacheData.y) this._cacheData.h = this._cacheData.y2 - this._cacheData.y;
    else if (this._cacheData.y2 < this._cacheData.y) this._cacheData.h = this._cacheData.y - this._cacheData.y2;
    else this._cacheData.h = this._cacheData.y;

    this._cacheData.h += this._cacheData.ls * 2;

    if (this._cacheData.x2 > this._cacheData.x) this._cacheData.w = this._cacheData.x2 - this._cacheData.x;
    else if (this._cacheData.x2 < this._cacheData.x) this._cacheData.w = this._cacheData.x - this._cacheData.x2;
    else this._cacheData.w = this._cacheData.x;

    this._cacheData.w += this._cacheData.ls * 2;
  }

  get shape() {
    return this._shape;
  }
  set shape(v) {
    this._shape = v;
  }
  get block() {
    return this._block;
  }
  set block(v) {
    this._block = v;
  }
  set stop(v) {
    this._stop = v;
  }
  set start(v) {
    this._start = v;
  }
  get connect() {
    return this._connect;
  }
  set connect(v) {
    this._connect = v;
  }
  get isCorrect() {
    return this._isCorrect;
  }
  set isCorrect(v) {
    this._isCorrect = v;
  }

  get color() {
    return this._colors;
  }
  get freeDrawing() {
    return this._freeDrawing;
  }
  get id() {
    return this._shape.id;
  }

  set remove(v) {
    this._remove = v;
  }
  get remove() {
    return this._remove;
  }

  setTime() {
    this._time = new Date();
  }

  get visible() {
    return this._container.visible;
  }
  set visible(v) {
    if (typeof this._effect !== 'string') this._container.visible = v;
    else {
      this._toVisible = v;
      this.setTime();
    }
  }

  get toVisible() {
    return this._toVisible;
  }
  set toVisible(v) {
    this._toVisible = v;
  }

  get effect() {
    return this._effect;
  }
  get speed() {
    return this._speed;
  }
  get wait() {
    return this._wait;
  }
  set wait(v) {
    this._wait = v;
  }
  get waitStart() {
    return this._waitStart;
  }
  get autoHide() {
    return this._autoHide;
  }
  get time() {
    return this._time;
  }
}
